import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Header } from "@/components/landing/Header";
import { Hero } from "@/components/landing/Hero";
import { Voucher } from "@/components/landing/Voucher";
import { Marquee } from "@/components/landing/Marquee";
import { FallSpecial } from "@/components/landing/FallSpecial";
import { Stats } from "@/components/landing/Stats";
import { Counters } from "@/components/landing/Counters";
import { Services } from "@/components/landing/Services";
import { BeforeAfter } from "@/components/landing/BeforeAfter";
import { WeddingDress } from "@/components/landing/WeddingDress";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { VideoSpot } from "@/components/landing/VideoSpot";
import { Manifesto } from "@/components/landing/Manifesto";
import { HonorSection } from "@/components/landing/HonorSection";
import { SchoolSpirit } from "@/components/landing/SchoolSpirit";
import { Coverage } from "@/components/landing/Coverage";
import { MaricopaSpotlight } from "@/components/landing/MaricopaSpotlight";
import { Booking } from "@/components/landing/Booking";
import { Gallery } from "@/components/landing/Gallery";
import { Testimonials } from "@/components/landing/Testimonials";
import { ReviewSpotlight } from "@/components/landing/ReviewSpotlight";
import { Footer } from "@/components/landing/Footer";
import { MobileBar } from "@/components/landing/MobileBar";
import { Seo } from "@/components/Seo";
import { scrollToId, HOME_TITLE, HOME_META, BUSINESS_JSONLD } from "@/lib/site";

export default function Home() {
  const { state } = useLocation();

  useEffect(() => {
    if (state?.scrollTo) {
      const t = setTimeout(() => scrollToId(state.scrollTo), 450);
      window.history.replaceState({}, "");
      return () => clearTimeout(t);
    }
  }, [state]);

  return (
    <div data-testid="home-page" className="bg-slate-50 text-slate-900">
      <Seo title={HOME_TITLE} description={HOME_META} path="/" jsonLd={BUSINESS_JSONLD} />
      <Header />
      <main>
        <Hero />
        <Voucher />
        <Marquee />
        <Counters />
        <FallSpecial />
        <Stats />
        <Services />
        <BeforeAfter />
        <WeddingDress />
        <HowItWorks />
        <VideoSpot />
        <Manifesto />
        <HonorSection />
        <SchoolSpirit />
        <Coverage />
        <MaricopaSpotlight />
        <Testimonials />
        <ReviewSpotlight />
        <Booking />
        <Gallery />
      </main>
      <Footer />
      <MobileBar />
    </div>
  );
}
